import HabilidadService from 'src/modules/habilidad/habilidadService';
import Errors from 'src/modules/shared/error/errors';
import Message from 'src/view/shared/message';
import { getHistory } from 'src/modules/history';
import { i18n } from 'src/i18n';

const prefix = 'HABILIDAD_FORM';

const habilidadFormActions = {
  INIT_STARTED: `${prefix}_INIT_STARTED`,
  INIT_SUCCESS: `${prefix}_INIT_SUCCESS`,
  INIT_ERROR: `${prefix}_INIT_ERROR`,

  CREATE_STARTED: `${prefix}_CREATE_STARTED`,
  CREATE_SUCCESS: `${prefix}_CREATE_SUCCESS`,
  CREATE_ERROR: `${prefix}_CREATE_ERROR`,

  UPDATE_STARTED: `${prefix}_UPDATE_STARTED`,
  UPDATE_SUCCESS: `${prefix}_UPDATE_SUCCESS`,
  UPDATE_ERROR: `${prefix}_UPDATE_ERROR`,

  doInit: (id) => async (dispatch) => {
    try {
      dispatch({
        type: habilidadFormActions.INIT_STARTED,
      });

      let record = {};

      const isEdit = Boolean(id);

      if (isEdit) {
        record = await HabilidadService.find(id);
      }

      dispatch({
        type: habilidadFormActions.INIT_SUCCESS,
        payload: record,
      });
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: habilidadFormActions.INIT_ERROR,
      });

      getHistory().push('/habilidad');
    }
  },

  doCreate: (values) => async (dispatch) => {
    try {
      dispatch({
        type: habilidadFormActions.CREATE_STARTED,
      });

      await HabilidadService.create(values);

      dispatch({
        type: habilidadFormActions.CREATE_SUCCESS,
      });

      Message.success(
        i18n('entities.habilidad.create.success'),
      );

      getHistory().push('/habilidad');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: habilidadFormActions.CREATE_ERROR,
      });
    }
  },

  doUpdate: (id, values) => async (dispatch, getState) => {
    try {
      dispatch({
        type: habilidadFormActions.UPDATE_STARTED,
      });

      await HabilidadService.update(id, values);

      dispatch({
        type: habilidadFormActions.UPDATE_SUCCESS,
      });

      Message.success(
        i18n('entities.habilidad.update.success'),
      );

      getHistory().push('/habilidad');
    } catch (error) {
      Errors.handle(error);

      dispatch({
        type: habilidadFormActions.UPDATE_ERROR,
      });
    }
  },
};

export default habilidadFormActions;
